export const createApprovalLineState = () => ({
  depHeads: [],
  safetyManager: null,
  smId: '',
  initialized: false,
  touched: false,
});

export const normalizeApprovalLine = (rows = [], depApproval = []) => {
  const managers = depApproval.flatMap((dep) =>
    (dep.managers || []).map((manager) => ({
      ...manager,
      depCd: dep.depCd,
      depNm: dep.depNmLast || dep.depNm,
    }))
  );

  const depHeads = rows
    .filter((row) => row.approverType === 'INTERMEDIATE')
    .sort((a, b) => (a.no || 0) - (b.no || 0))
    .map((row) => {
      const manager = managers.find((item) => item.id === row.id);

      return {
        depCd: manager?.depCd || '',
        depNm: manager?.depNm || '',
        headId: row.id,
        headNm: manager?.name || '',
        position: manager?.position || '',
        photo: manager?.photo || '',
        no: row.no || 0,
      };
    });

  const finalRow = rows
    .filter((row) => row.approverType === 'FINAL')
    .sort((a, b) => (a.no || 0) - (b.no || 0))[0];
  const finalManager = managers.find((item) => item.id === finalRow?.id);

  const safetyManager = finalRow
    ? {
        depCd: finalManager?.depCd || '',
        depNm: finalManager?.depNm || '',
        smId: finalRow.id,
        smNm: finalManager?.name || '',
        position: finalManager?.position || '',
        photo: finalManager?.photo || '',
        no: finalRow.no || 0,
      }
    : null;

  return {
    depHeads,
    safetyManager,
    smId: safetyManager?.smId || '',
  };
};
